import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const hasConfig =
  !!firebaseConfig.apiKey &&
  !!firebaseConfig.authDomain &&
  !!firebaseConfig.projectId;

if (!hasConfig && typeof window !== "undefined") {
  console.warn(
    "⚠️ Firebase config missing (REACT_APP_FIREBASE_*). Auth and Firestore disabled.",
  );
}

const app: FirebaseApp | undefined = hasConfig
  ? getApps().length === 0
    ? initializeApp(firebaseConfig)
    : getApp()
  : undefined;

export { app, firebaseConfig, hasConfig };
export default app;
